import React, { useEffect, useState, useRef } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { EvaSchiffererNavItems } from './EvaSchiffererNav';
import { AngelikaSturnNavItems } from './AngelikaSturnNav';
export function Header() {
  const [animationEnded, setAnimationEnded] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const videoRef = useRef<HTMLVideoElement>(null);
  const location = useLocation();
  const isEvaSchiffererPage = location.pathname.startsWith('/eva_schifferer');
  const isAngelikaSturnPage = location.pathname.startsWith('/angelika_sturny');
  const isHomePage = location.pathname === '/';
  useEffect(() => {
    // Video abspielen, wenn die Komponente geladen wird
    if (videoRef.current) {
      videoRef.current.play().catch(error => {
        console.error('Video konnte nicht automatisch abgespielt werden:', error);
        setTimeout(() => setAnimationEnded(true), 3000);
      });
    }
    setMobileMenuOpen(false);
  }, [location.pathname]);
  const handleVideoEnded = () => {
    setAnimationEnded(true);
  };
  const toggleMobileMenu = () => {
    setMobileMenuOpen(!mobileMenuOpen);
  };
  return <header className="w-full bg-white py-4 px-6 md:px-12 shadow-sm fixed top-0 z-10" data-id="element-142">
      <div className="max-w-7xl mx-auto" data-id="element-143">
        <div className="flex justify-between items-center" data-id="element-144">
          <div className="flex items-center h-24" data-id="element-145">
            <Link to="/" data-id="element-146">
              {!animationEnded ? <video ref={videoRef} src="https://server-staging.de/downloads/Animation-Logo-3Sek-final2.mp4" className="h-24 w-auto object-contain" muted playsInline onEnded={handleVideoEnded} data-id="element-147" /> : <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/sBeLHqEvA69hG4RGUSQpxM/Logo-Schifferer_Sturny-final2.png" alt="Praxis für Beratung und Psychotherapie Logo" className="h-24 w-auto object-contain" data-id="element-148" />}
            </Link>
          </div>
          {/* Desktop Navigation */}
          <nav className="hidden lg:flex space-x-8" data-id="element-149">
            {!isHomePage && <Link to="/" className="text-gray-600 hover:text-[#c2cde0] transition-colors" data-id="element-150">
                Startseite
              </Link>}
            <Link to="/angelika_sturny" className={`${isAngelikaSturnPage ? 'text-[#cda8be] font-semibold' : 'text-gray-600 hover:text-[#cda8be]'} transition-colors`} data-id="element-151">
              Praxis München
            </Link>
            <Link to="/eva_schifferer" className={`${isEvaSchiffererPage ? 'text-[#c2cde0] font-semibold' : 'text-gray-600 hover:text-[#c2cde0]'} transition-colors`} data-id="element-152">
              Praxis Frankfurt
            </Link>
          </nav>
          {/* Mobile Menu Button */}
          <button className="lg:hidden text-gray-600 focus:outline-none" onClick={toggleMobileMenu} aria-label="Toggle mobile menu" data-id="element-153">
            {mobileMenuOpen ? <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-154">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" data-id="element-155" />
              </svg> : <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-156">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" data-id="element-157" />
              </svg>}
          </button>
        </div>
        {/* Eva Schifferer Unternavigation im Header */}
        {isEvaSchiffererPage && <div className="hidden lg:block mt-0 border-t border-gray-100 pt-4" data-id="element-158">
            <div className="overflow-visible" data-id="element-159">
              <ul className="flex justify-end space-x-4 md:space-x-5" data-id="element-160">
                <EvaSchiffererNavItems data-id="element-161" />
              </ul>
            </div>
          </div>}
        {/* Angelika Sturny Unternavigation im Header */}
        {isAngelikaSturnPage && <div className="hidden lg:block mt-0 border-t border-gray-100 pt-4" data-id="element-162">
            <div className="overflow-visible" data-id="element-163">
              <ul className="flex justify-end space-x-4 md:space-x-5" data-id="element-164">
                <AngelikaSturnNavItems data-id="element-165" />
              </ul>
            </div>
          </div>}
      </div>
      {/* Mobile Menu */}
      {mobileMenuOpen && <div className="lg:hidden fixed inset-0 top-24 bg-white z-50 overflow-y-auto" data-id="element-166">
          <div className="px-6 py-6 space-y-6 border-t border-gray-100" data-id="element-167">
            <nav className="flex flex-col space-y-4" data-id="element-168">
              {!isHomePage && <Link to="/" className="text-gray-600 hover:text-[#c2cde0] transition-colors py-2 text-lg" onClick={() => setMobileMenuOpen(false)} data-id="element-169">
                  Startseite
                </Link>}
              <Link to="/angelika_sturny" className={`${isAngelikaSturnPage ? 'text-[#cda8be] font-semibold' : 'text-gray-600 hover:text-[#cda8be]'} transition-colors py-2 text-lg`} onClick={() => setMobileMenuOpen(false)} data-id="element-170">
                Praxis München
              </Link>
              <Link to="/eva_schifferer" className={`${isEvaSchiffererPage ? 'text-[#c2cde0] font-semibold' : 'text-gray-600 hover:text-[#c2cde0]'} transition-colors py-2 text-lg`} onClick={() => setMobileMenuOpen(false)} data-id="element-171">
                Praxis Frankfurt
              </Link>
            </nav>
            {/* Eva Schifferer Unternavigation im Mobile Menu */}
            {isEvaSchiffererPage && <div className="mt-4 pt-4 border-t border-gray-100" data-id="element-172">
                <ul className="space-y-3" data-id="element-173">
                  <EvaSchiffererNavItems isMobile={true} closeMobileMenu={() => setMobileMenuOpen(false)} data-id="element-174" />
                </ul>
              </div>}
            {/* Angelika Sturny Unternavigation im Mobile Menu */}
            {isAngelikaSturnPage && <div className="mt-4 pt-4 border-t border-gray-100" data-id="element-175">
                <ul className="space-y-3" data-id="element-176">
                  <AngelikaSturnNavItems isMobile={true} closeMobileMenu={() => setMobileMenuOpen(false)} data-id="element-177" />
                </ul>
              </div>}
          </div>
        </div>}
    </header>;
}